/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import iconSet from 'quasar/icon-set/material-icons'



import {QSelect,QLayout,QHeader,QFooter,QPageContainer,QPage,QToolbar,QToolbarTitle,QTabs,QTab,QTabPanels,QTabPanel,QLinearProgress,QScrollArea,QSpinnerDots,QSpinner,QRouteTab,QList,QItem,QItemSection,QItemLabel,QChip,QField,QInput,QBtn,QIcon,QTooltip,QSlider,QCheckbox,QChatMessage,QDialog,QTable,QCard,QSpace,QCardSection,QCardActions,QSpinnerIos,QPageSticky,QPageScroller,QMenu,QSeparator,QCarousel,QCarouselSlide,QBadge,Ripple,TouchHold,ClosePopup,Dialog,Notify,Loading,LocalStorage,AppVisibility,BottomSheet,LoadingBar} from 'quasar'



export default { config: {"capacitor":{"iosStatusBarPadding":true,"backButton":false},"loadingBar":{"skipHijack":true}},iconSet,components: {QSelect,QLayout,QHeader,QFooter,QPageContainer,QPage,QToolbar,QToolbarTitle,QTabs,QTab,QTabPanels,QTabPanel,QLinearProgress,QScrollArea,QSpinnerDots,QSpinner,QRouteTab,QList,QItem,QItemSection,QItemLabel,QChip,QField,QInput,QBtn,QIcon,QTooltip,QSlider,QCheckbox,QChatMessage,QDialog,QTable,QCard,QSpace,QCardSection,QCardActions,QSpinnerIos,QPageSticky,QPageScroller,QMenu,QSeparator,QCarousel,QCarouselSlide,QBadge},directives: {Ripple,TouchHold,ClosePopup},plugins: {Dialog,Notify,Loading,LocalStorage,AppVisibility,BottomSheet,LoadingBar} }

